export default "__VITE_PUBLIC_ASSET__1bfc9527__"